import { PayloadAction } from '@reduxjs/toolkit';
import { searchRequest } from 'core/services/product';
import { ISearchReducer, ISearchSelection, selectSearchResult, updateSearch } from 'core/slices/search';
import { all, call, fork, put, select, debounce, takeLatest } from 'redux-saga/effects';
import { RootState } from 'types';
import { SearchType } from 'types/domain/search';
import { selectSession } from 'core/selectors/product/session';
import { ISessionReducer } from 'core/slices/session';
import { startModule } from './module/start';

function* updateSearchSaga() {
  const search: ISearchReducer = yield select((state: RootState) => state.core.search);
  const session: ISessionReducer = yield select(selectSession);

  if (search.term?.length && [SearchType.LEARNER, SearchType.MODULE, SearchType.ORG_USER].includes(search.searchType))
    yield put(
      yield call(searchRequest, {
        term: search.term,
        filter: search.filter,
        searchType: search.searchType,
        sessionId: session.session?.id,
        pagerInfo: { page: 0 },
      }),
    );
}

function* selectSearchSaga(action: PayloadAction<ISearchSelection>) {
  const search: ISearchReducer = yield select((state: RootState) => state.core.search);
  if (action.payload.moduleId && search.searchType === SearchType.LEARNER) {
    yield startModule(action.payload.moduleId, action.payload.actionId, true);
  }
}

function* watchSelectSearch() {
  yield takeLatest(selectSearchResult, selectSearchSaga);
}

function* watchSearch() {
  yield debounce(1000, updateSearch, updateSearchSaga);
}

export default function* searchSaga() {
  yield all([fork(watchSearch), fork(watchSelectSearch)]);
}
